<template>
  <div class="title-item">
    <div class="title-input">
      <el-input v-model="value.title" placeholder="请输入内容"></el-input>
    </div>
    <div class="title-color">
      <el-radio-group v-model="value.color">
        <el-radio label="#FFF">白色</el-radio>
        <el-radio label="#000">黑色</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>
<script>
export default {
  name: "titleItem",
  props: ['value'],
  created() {
    console.log( this.value)
  }
}
</script>
<style scoped lang="scss">
.title-item{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title-input{
    flex: 0 150px;
    width: 150px;
    margin-right: 10px;
  }
  .title-color{
    flex: 1;
  }
}
</style>
